import { render, staticRenderFns } from "./researchForm.vue?vue&type=template&id=5696e044&scoped=true&"
import script from "./researchForm.vue?vue&type=script&lang=js&"
export * from "./researchForm.vue?vue&type=script&lang=js&"
import style0 from "./researchForm.vue?vue&type=style&index=0&id=5696e044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696e044",
  null
  
)

export default component.exports